import { render, staticRenderFns } from "./LogoLonelyPlanet.vue?vue&type=template&id=88fb48c4&scoped=true&"
import script from "./LogoLonelyPlanet.vue?vue&type=script&lang=js&"
export * from "./LogoLonelyPlanet.vue?vue&type=script&lang=js&"
import style0 from "./LogoLonelyPlanet.vue?vue&type=style&index=0&id=88fb48c4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88fb48c4",
  null
  
)

export default component.exports